<div class="rating-bar-container">
  <div class="rating-bar-progress"
       [ngStyle]="{ 'width': ratingValueInPercents + '%' }">
  </div>
</div>
